import { getUrl, Request } from "../../request";

export const postNotification = (
  device_token,
  operating_system,
  user_agent,
  city_id
) => {
  return Request.post(getUrl("/api/v1/notification/firebase/"), {
    device_token,
    operating_system,
    user_agent,
    city_id,
  });
};

export const getNotifications = ({ limit = 10, interests } = {}) =>
  Request.get(getUrl("/api/v1/notification/notif/?site=gmall"), {
    limit,
    interests: Array.isArray(interests) ? interests.join(",") : undefined,
  });

export const seenNotification = (notification_id) =>
  Request.post(getUrl("/api/v1/notification/notif/?site=gmall"), {
    notification_id,
  });

export const retrieveNotification = (notification_id) =>
  Request.get(
    getUrl(`/api/v1/notification/notif/${notification_id}/?site=gmall`)
  );
